// import external dependencies

import "jquery";

// Import everything from autoload
import "./autoload/_wowjs.js"

// Import modules
import "./modules/global";
import "./modules/ajax";
import "./modules/select";

jQuery(document).ready(() => {});



// WEBPACK FOOTER //
// ./scripts/main.js